module.exports = __webpack_public_path__ + "media/images/recruit/top/stone_small-7eff70a060b85c14d9a824c8c9c06cb3.png";